export const SET_SSR = 'SET_SSR';
